<template>
  <div class="_content">
    <div
      v-if="this.userRole === '老板' || this.userRole === '店长'"
      class="main-cont"
    >
      <!-- tabs. -->
      <div class="pay-tabs">
        <div
          :class="{ 'active-tab': tabIndex === 0 }"
          @click="handleTabIndex(0)"
        >
          出账管理
        </div>
        <div
          :class="{ 'active-tab': tabIndex === 1 }"
          @click="handleTabIndex(1)"
        >
          结算明细
        </div>
      </div>
      <div
        class="header-bg"
        v-if="(tabIndex === 0 || tabIndex === 1) && childIndex != 1"
      >
        <div class="img-bg"></div>
        <div class="con-bg">
          <div class="select-year">
            <div
              class="select"
              style=""
              v-if="(tabIndex === 0 || tabIndex === 1) && childIndex != 1"
            >
              <p
                v-html="yearValue"
                class="yearClass"
                @click="yearVisible = !yearVisible"
              ></p>
              <img :src="icon4" alt="" class="up" />
              <ul class="yearUl" v-if="yearVisible">
                <li
                  class="yearLi"
                  :class="yearValue == item.value ? 'acbg' : ''"
                  v-for="(item, index) in year"
                  :key="index"
                  @click="changeYearValue(item.value)"
                >
                  {{ item.value }}
                </li>
              </ul>
            </div>
          </div>
          <div class="order-num" v-if="tabIndex === 0 && childIndex != 1">
            <div class="order">
              <p class="text">核销订单数</p>
              <p class="num">{{ countOrderNum }}</p>
            </div>
            <div class="order">
              <p class="text">核销订单总金额（元）</p>
              <p class="num">{{ countOrderPrice }}</p>
            </div>
          </div>
          <div class="order-num" v-if="tabIndex == 1">
            <div class="order">
              <p class="text">已结款订单数</p>
              <p class="num">{{ countOrderNum2 }}</p>
            </div>
            <div class="order">
              <p class="text">核销总金额（元）</p>
              <p class="num">{{ countOrderPrice2 }}</p>
            </div>
          </div>
          <div class="header-tips" v-if="tabIndex === 0 && childIndex != 1">
            每月10号之前小鲲车服会完成上月已出账订单的审核，每月11号会对审核通过的账单进行打款
          </div>

          <div
            class="header-tips"
            v-if="tabIndex === 1"
            style="text-align: center"
          >
            每月11号会对审核通过的账单进行打款
          </div>
        </div>
      </div>

      <!-- 出账 -->
      <div v-if="tabIndex === 0" class="orderCard">
        <div class="child1" v-if="childIndex == 0">
          <van-collapse
            v-model="activeNames"
            v-for="(item, idx) in orderList"
            :key="idx"
            class="collapse-bill"
            @change="handleItem(item, idx)"
            accordion
          >
            <van-collapse-item :name="idx" class="collapse-position">
              <template #title>
                <span class="position"></span>
                <div class="bill-title">
                  <p class="title">
                    {{ item.year }}年{{ item.month }}月&nbsp;<span
                      class="title-num"
                      >{{ item.shopBillQuantity || 0 }}笔</span
                    >
                  </p>
                  <p class="num">￥{{ item.totalAmount || 0 }}</p>
                </div>
              </template>
              <div
                class="bill-info"
                v-for="(item1, index1) in childrenOrder"
                :key="index1"
              >
                <div v-if="item1.shopBillQuantity" class="bill-info2">
                  <p class="bill-num">{{ item1.shopBillQuantity || 0 }}笔</p>
                  <p class="bill-info2-status">
                    ￥{{ item1.totalAmount || 0 }}&nbsp;
                    <span
                      class="setClass"
                      :style="{ background: remitStatusColor[item1.status] }"
                    >
                      {{ shopStatus[item1.status] }}</span
                    >
                  </p>
                </div>
              </div>
            </van-collapse-item>
          </van-collapse>
        </div>

        <div class="child2" v-if="childIndex == 1">
          <div class="main">
            <div class="conten">
              <div
                class="content-text"
                v-for="(item, index) in orderList"
                :key="index"
              >
                <van-checkbox
                  v-model="item.select"
                  @change="handleRadio"
                ></van-checkbox>
                <div class="right">
                  <p class="year">{{ item.year }}年{{ item.month }}月</p>

                  <div class="num">
                    <p class="left">
                      {{ item.shopBillQuantity || 0 }}笔<span
                        class="solid"
                      ></span
                      >￥{{ item.totalAmount || 0 }}
                    </p>

                    <span class="span">未出账</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="btn2" v-if="childIndex == 1">
        <van-checkbox
          v-model="checkedAll"
          @click="checkedAll ? handleCheckAll() : handleCheckAllFlase()"
          >全选</van-checkbox
        >
        <div class="center">
          <div class="center-count">
            <p class="count">
              合计：<img :src="icon3" alt="" /><span>{{ sumPrice }}</span>
            </p>
            <p class="count-name">
              本次合计出账：<span>{{ sumOrder }}笔</span>
            </p>
          </div>
          <p class="a-apply" @click="checkBillSatus">立即申请</p>
        </div>
      </div>

      <!-- 结款  -->
      <div v-if="tabIndex === 1" class="recordsCard">
        <van-checkbox-group v-model="chosedBill">
          <div
            class="recordsCard-box marginTop"
            v-for="(item, index) in recordsData && recordsData.list"
            :key="index"
          >
            <div class="box-item paddingBottom bottom-line">
              <span class="solid"></span>

              <div class="title">
                <van-checkbox
                :disabled="item.status !== 7"
                  v-if="billFlag === 1 && !isInvoiceCanALLChosed"
                  @click="handleCheckInvoice()"
                  :name="item.id"
                  style="margin-right: 0.25rem;"
                />
                出账编号：{{ item.settlementBillNo }}
              </div>
              <div class="val">
                <!--  paymentStatus 
                                    (3, "待打款"),(4,"打款中"),(5, "结款成功"),(6,"结款失败")
                                 -->
                <p
                  class="setClass"
                  :style="{ background: remitStatusColor[item.status] }"
                >
                  {{ shopStatus[item.status] }}
                </p>
                <!-- <p class="themeColor" v-if="item.paymentStatus === 4">打款中</p>
              <p class="themeColor" v-if="item.paymentStatus === 6">打款中</p>
              <p class="themeColor" v-if="item.paymentStatus === 5">结款成功</p> -->
              </div>
            </div>

            <div class="box-item paddingTop">
              <div class="title">出账时间</div>
              <div class="val">
                {{ item.createdTime }}
              </div>
            </div>

            <div class="box-item paddingTop">
              <div class="title">收款账户</div>
              <div class="val">
                {{ item.bankName }}-{{ item.bankBranchName }}
              </div>
            </div>

            <div class="box-item marginTop paddingTop">
              <div class="title">收款账号</div>
              <div class="val">
                {{ item.bankAccountName }}
              </div>
            </div>

            <div
              class="box-item marginTop paddingTop"
              v-if="item.paymentExplain"
            >
              <div class="title">异常提醒</div>
              <div class="val val2">
                {{ item.paymentExplain }}
              </div>
            </div> 

            <div class="orderNum">
              <p class="orderName">
                订单数：<span>{{ item.billCount }}</span>
              </p>
              &nbsp;&nbsp;&nbsp;
              <p class="orderName">
                订单总金额：￥<span>{{ item.settlementPrice }}</span
                >元
              </p>
            </div>

            <div class="box-item marginTop paddingTop" v-if="billFlag === 1 && item.invoiceUrl">
              <div class="title">发票</div>
              <div class="val">
                <p @click="handleReviewInvoice(item.invoiceUrl)" style="color: #1890ff;"> 点击查看 </p>
              </div>
            </div>

          </div>
        </van-checkbox-group>
        <van-empty
          v-if="this.recordsData.total === 0"
          description="无结款记录"
        />
      </div>
      <div v-if="tabIndex === 1 && billFlag === 1 && !isInvoiceCanALLChosed" class="upload-invoice">
        <div class="upload-invoice-btn-left">
          <van-checkbox
          :disabled="isInvoiceCanALLChosed"
            v-model="checkedInvoiceAll"
            @click="
              checkedInvoiceAll
                ? handleCheckInvoiceAll()
                : handleCheckInvoiceAllFlase()
            "
            >全选</van-checkbox
          >
        </div>
        <div class="upload-invoice-btn-right" @click="openDrawer">
          <span>上传发票</span>
        </div>
      </div>
      <!-- 分页 :total-items= total  总数量-->
      <van-pagination
        v-model="currentPage"
        v-if="this.recordsData.total > 3 && tabIndex === 1"
        :total-items="this.recordsData.total"
        items-per-page="50"
        force-ellipses
        :show-page-size="50"
        @change="changePage($event)"
      />
    </div>
    <div
      v-if="tabIndex === 0 && childIndex != 1"
      class="btn"
      @click="handleApplyBill()"
    >
      <tt-button
        text="一键申请出账"
        :type="applyNum > 1 ? 'disabled' : 'primary'"
      ></tt-button>
    </div>

    <van-empty
      v-else-if="this.userRole === '员工' || this.userRole === ''"
      image="error"
      description="权限不足或网络错误"
    />

    <!-- 弹框 -->
    <van-popup
      v-model="remitVisible"
      round
      position="bottom"
      class="custormRemit"
      :close-on-click-overlay="false"
    >
      <p class="title">确认结账信息</p>
      <div class="custormRemit-content">
      <div class="account first">
        <p>收款账户</p>
        <p>
          {{ shopBankCardInfo.bankAccount }}({{ shopBankCardInfo.bankName }}-{{
            shopBankCardInfo.bankBranchName
          }})
        </p>
      </div>
      <div class="account">
        <p>身份证号码</p>
        <p>{{ shopBankCardInfo.bankAccountIdCard }}</p>
      </div>
      <div class="account">
        <p>收款账号</p>
        <p>{{ shopBankCardInfo.bankAccountName }}</p>
      </div>
      <div class="account">
        <p>收款人手机号</p>
        <p>{{ shopBankCardInfo.bankAccountPhone }}</p>
      </div>
      <div class="account">
        <p>联行号</p>
        <p>{{ shopBankCardInfo.bankAccountNumber }}</p>
      </div>
      <div class="explain">
        <p class="explain-title">结账说明</p>
        <p class="explain-info">
          1、每月可提交1次结账申请<br />
          2、提交申请后，工作人员会在次月5号之前完成账单审核<br />
          3、审核成功后，财务人员会在11号之前完成打款<br />
          4、请在申请结账后务必确保打款银行账户信息已录入且正常无误，否则可能影响打款
          <p style="color:red" v-if="billFlag === 1">5、提交出账申请，审核通过后，成功上传发票即可在规定时间收到打款</p>
        </p>
      </div>

      <div class="classChecked" v-if="shopBankCardInfo.isCheck">
        <van-checkbox v-model="checked" checked-color="#4078ff"
          >我已确认收款信息无误且知晓结账说明</van-checkbox
        >
      </div>
      </div>
      <div class="btn-2">
        <p class="close" @click="close">暂不结账</p>
        <p v-if="billFlag===1 && shopBankCardInfo.isCheck" class="confim" @click="handleInvoiceApply">
          确认申请结账
        </p>
        <p v-if="billFlag!==1 && shopBankCardInfo.isCheck" class="confim" @click="handleApply">
          确认申请结账
        </p>
        <p v-if="!shopBankCardInfo.isCheck" class="confim" @click="goUdate">去完善收款信息</p>
      </div>
    </van-popup>
    <!--不可申请 -->
    <van-popup v-model="noApplyVisible" class="applycustorm">
      <p class="title">您本月已申请过1次结账了，不可再次申请！</p>
      <p class="explan">结账说明</p>
      <p class="text">
        1、每月仅可提交1次结账申请<br />
        2、提交申请后，工作人员会在次月5号之前完成账单审核<br />
        3、审核成功后，财务人员会在11号之前完成打款<br />
        4、请在申请结账后务必确保打款银行账户信息已录入且正常无误，否则可能影响打款
      </p>

      <p class="btn" @click="noApplyVisible = false">我已知晓</p>
    </van-popup>

    <!-- 收款信息不全 -->
    <van-popup v-model="infoVisible" class="infocustorm">
      <p class="title">补全信息提示</p>
      <p class="text">
        您的收款账户信息不全，请联系您的商户专员进行补全后再来申请！
      </p>
      <p class="btn" @click="infoVisible = false">我知道了</p>
    </van-popup>
    
    <!--出账提示-->
     <van-popup v-model="isShowTips" class="infocustorm">
      <p class="title">温馨提示</p>
      <p class="text">
        提交完出账申请，审核通过后需在<span style="font-weight: bolder;">结算明细</span>上传发票，即可在规定期限内收到打款
      </p>
      <p class="btn" @click="handleApply">确认</p>
    </van-popup>
    <van-dialog
      v-model="isShow"
      title="订单出账状态提示"
      show-cancel-button
      class="tips-dialog"
      confirm-button-text="立即申请"
      cancel-button-text="暂不申请"
      @cancel="isShow = false"
      @confirm="submitApply"
    >
      <p class="text">
        您提交的订单中有<span style="color: red;">{{ djNum }}笔</span
        >目前处于冻结状态，暂时无法直接进行出账，请联系市场经理为您处理。
      </p>
      <p class="text">
        另外<span style="color: green;">{{ kczNum }}笔</span
        >订单现处于可出账状态，是否申请出账?
      </p>
    </van-dialog>
    <div
      class="upload-invoice-confirm"
      v-if="drawerShow"
      @click="drawerShow = false"
    >
      <div
        class="popup-content"
        @click.stop
        :style="{ height: invoiceFileUrl ? '16.1rem' : '11.48rem' }"
      >
        <div class="popup-cont-pic">
          <div class="popup-cont-piccont-left" @click="showCamera = true"></div>
          <div class="popup-cont-piccont-right">
            <div class="img-div">
              <img
                @click="handleReviewInvoice('https://res.xiaokunkeji.cn/image/2025/09/18/00798cf42b634dcc90f0bfb6fd127cc3.jpg')"
              src="https://res.xiaokunkeji.cn/image/2025/09/18/00798cf42b634dcc90f0bfb6fd127cc3.jpg"
              />
            </div>
            <p>发票示例</p>
          </div>
        </div>
        <div class="popup-cont-pic2" v-if="invoiceFileUrl">
          <div
            class="popup-cont-piccont-left"
            v-if="invoiceFileType === 'image'"
          >
            <div class="delete-btn" @click="deleteInvoiceUrl"></div>
            <img :src="invoiceFileUrl" />
          </div>
          <div
            class="popup-cont-piccont-left"
            v-if="invoiceFileType === 'file'"
          >
           <div class="delete-btn" @click="deleteInvoiceUrl"></div>
            <img
              src="https://res.xiaokunkeji.cn/image/2025/09/16/fc7054f3f5564a238259f7d3e957d7bf.png"
            />
          </div>
        </div>
        <!-- 这里可以添加上传图片的表单或其他内容 -->
        <div class="popup-bth">
          <div class="popup-bth-left" @click="closeUploadInvoice">
            取消
          </div>
          <div class="popup-bth-right" @click="uploadInvoice">
            确认上传
          </div>
        </div>
      </div>
    </div>
    <!-- 提示需签订协议 -->
    <van-dialog
      v-model="visibleAssign"
      :showConfirmButton="true"
      :showCancelButton="true"
      confirmButtonText="去签署"
      title="提示"
      @confirm = "toAssignMent"
      class="custormTips4"
    >
      <p class="t-content4">您好,合作协议已更新需重新签署</p>
    </van-dialog>
    <camera
      :showCamera="showCamera"
      @fileUploaded="fileUploaded"
      @close="closeCamera"
    ></camera>
    <review :isShow="isReviewInvioce" :url="reviewInvioceUrl" @close="closeRewiveInvoice"></review>
  </div>
</template>
<script>
import { ImagePreview } from "vant"
import review from  "@/components/review";
import config from "@/configs/config";
import ttButton from "@/components/ttButton";
import camera from "@/components/camera";
import moment from "moment";
import { remitStatusColor, shopStatus } from "../../commons/enmu";
import "moment/locale/zh-cn";
moment.locale("zh-cn");
// import VConsole from "vconsole/dist/vconsole.min.js"; // import vconsole

export default {
  components: {
    ttButton,
    camera,
    review
  },
  data() {
    return {
      currentShopData:{},
      visibleAssign:false,
      isShowTips:false, //出账提示，有发票才需要
      isReviewInvioce: false,
      reviewInvioceUrl: null,
      invoiceFile: "",
      invoiceFileUrl: null, //上传图片链接，展示用，不用传
      invoiceFileType: null, //上传图片类型，展示用，不用传
      showCamera: false, // 上传图片
      drawerShow: false, //上传发票图片抽屉
      chosedBill: [],
      year: [],
      remitStatusColor,
      shopStatus,
      yearValue: 2023,
      checked: false,
      checkedAll: false,
      checkedInvoiceAll: false,
      remitVisible: false,
      noApplyVisible: false,
      orderList: [],
      childrenOrder: [],
      recordsData: {},
      currentPage: 1,
      userRole: "",
      shopId: "",
      tabIndex: 0,
      childIndex: 0,
      countOrderNum: 0,
      countOrderPrice: 0,
      countOrderNum2: 0,
      countOrderPrice2: 0,
      applyNum: "",
      infoVisible: false,
      shopBankCardInfo: {},
      sucessNum: "",
      monthList: [],
      activeNames: 0,
      icon9: require("../../imgs/tc-icon-9.png"),
      icon3: require("../../imgs/icon-3.png"),
      icon4: require("../../imgs/icon-4.png"),

      sumOrder: 0,
      sumPrice: 0,
      yearVisible: false,
      vConsolePhone: ["17534753224", "19956900629"],
      isShow: false,
      djNum: 0, //冻结
      kczNum: 0 //可出账
    };
  },

  computed: {
    user() {
      return tuhu.store.state.userInfo;
    },
    assignment() {
      return tuhu.sessionStorage.getItem('assignment')
    },
    signFlag() {
      return tuhu.sessionStorage.getItem('signFlag') || null
    },
    billFlag() {
      return tuhu.store.state.userInfo.billFlag
    },
    isInvoiceCanALLChosed(){
      const list = []
      if(!this.recordsData.list) return 
       this.recordsData.list.forEach(item => {
        if(item.status === 7){
          list.push(item.id); // 将每个billNo添加到数组中
        }
      });
      return list.length < 1
    }
  },

  created() {
    this.init();
    //开启监听页面返回
    window.addEventListener("popstate", this.handleBackButton);
    //处理可选年份数据
    let yearList = [];
    this.yearValue = new Date().getFullYear(); //"2025-12-13"
    let subtractNum = this.yearValue - 2020;
    if (subtractNum === 0) return;
    for (let i = 0; i <= subtractNum; i++) {
      let temp = 2020 + i;
      yearList.push({
        value: temp,
        text: `${temp}年`
      });
    }
    this.year = yearList;
    console.log("yearList", this.year);
  },
  mounted() {
    // if (this.vConsolePhone.indexOf(tuhu.store.state.userInfo.phone) != -1) {
    //   let vConsole = new VConsole(); // init vconsole
    // }
  },
  destroyed() {
    //移除监听页面返回
    window.removeEventListener("popstate", this.handleBackButton);
  },
  methods: {
     async getShopData() {
      tuhu.showIndicator();
      try {
        const data = await tuhu.fetch(
              `${config.apis.SWITCH_SHOP}?shopId=${this.shopId}`
            );
            if (data && data.code === "200") {
              this.currentShopData = data.data;
              tuhu.sessionStorage.setItem('assignment', !data.data.assignment? '0' : '1')
              tuhu.sessionStorage.setItem('signFlag', data.data.signFlag)
            } else {
              tuhu.hideIndicator();
              tuhu.toast(data.message || "网络错误");
            }
          } catch (e) {
            tuhu.hideIndicator();
          }
    },
    // 去签订新的协议
    toAssignMent() {
      tuhu.navigateTo({
        url: '/pages/assignMent/index',
        query: {
          shopId: this.shopId,
          cryptoId: this.currentShopData.cryptoId
        }
      });
    },
     showImagePreview(val) {
            ImagePreview({
                images: [val], // 要预览的图片数组（支持多张）
                 closeable: true, // 显示关闭按钮
                 closeOnPopstate: true, // 浏览器后退时关闭预览
            });
        },
    deleteInvoiceUrl(){
      this.invoiceFile = null;
      this.invoiceFileType = null;
      this.invoiceFileUrl = null;
    },
    openDrawer(){
    if (this.chosedBill.length === 0) return tuhu.toast("请选择需要上传发票的账单");
    const filteredItems = this.recordsData.list.filter(item => this.chosedBill.includes(item.id));
     // 如果没有筛选到任何项，返回false（或根据业务需求调整）
      // 提取所有bankName并去重
    const bankNames = new Set(filteredItems.map(item => item.bankName));
    console.log(bankNames, filteredItems)
    if(bankNames.size>1){
        return tuhu.toast("收款信息主体不一致，无法一起上传。");
    }
        this.drawerShow = true
 
    },
    closeRewiveInvoice(){
      this.isReviewInvioce = false
      this.reviewInvioceUrl = null
    },
    handleReviewInvoice(val){
      if(val.includes('pdf')){
      this.reviewInvioceUrl = val
      this.isReviewInvioce = true
      }else{
        this.showImagePreview(val)
      }
    },
    closeUploadInvoice() {
      this.invoiceFile = null;
      this.invoiceFileType = null;
      this.invoiceFileUrl = null;
      this.drawerShow = false;
    },
    // 上传发票
    async uploadInvoice() {
      if (!this.invoiceFile) {
        return tuhu.toast("请上传发票图片");
      } else {
        tuhu.showIndicator();
        try {
          let formdata = new FormData();
          formdata.append("file", this.invoiceFile); // 文件对象
          formdata.append("shopId", this.shopId); // 文件对象
          formdata.append("settlementIds", this.chosedBill); // 文件对象
          formdata.append("url", this.invoiceFileUrl); // 文件对象
          let data = await tuhu.fetch(`${config.apis.UPLOAD_INVOICE}`, {
            method: "post",
            body: formdata
          });
          if (data && data.code === "200") {
            this.drawerShow  = false
            this.chosedBill = []
            this.checkedInvoiceAll = false;
            this.invoiceFile = null;
            this.invoiceFileType = null;
            this.invoiceFileUrl = null;
            tuhu.toast(data.message || "上传成功");
            await this.getRecordsInfo();
          } else {
            tuhu.hideIndicator();

            tuhu.toast(data.message || "网络错误");
          }
        } catch (e) {
          tuhu.hideIndicator();
        }
      }
    },
    closeCamera() {
      this.showCamera = false;
    },
    async fileUploaded(val, type) {
      tuhu.showIndicator();
      this.invoiceFileType = type;
      this.invoiceFile = val;
      console.log(val.size)
      const isLt8M = val.size / 1024 / 1024 < 8
      if (!isLt8M) {
        this.submitLoading = false
        tuhu.toast('只能上传8MB（含）内大小的文件')
        return tuhu.hideIndicator();
      }
      const mess = new FormData();
      mess.append("multipartFile", this.invoiceFile);
      await tuhu
        .fetch(`${config.apis.UPLOAD_URL}`, {
          method: "post",
          body: mess
        })
        .then(res => {
          console.log("res", res);
          if (res.code === "200") {
            this.invoiceFileUrl = res.data;
          } else {
            tuhu.toast(res.message || "网络错误");
          }
        });
        tuhu.hideIndicator();
    },
    async changeYearValue(value) {
      this.activeNames = 0;
      this.yearValue = value;
      this.yearVisible = false;
      if (this.tabIndex == 0) {
        this.getOrderList();
      } else {
        this.getRecordsInfo();
      }
    },
    async changeLiYear() {},
    // tab切换
    async handleTabIndex(index) {
      this.tabIndex = index;
      this.childIndex = 0;
      this.yearVisible = false;
      if (index == 0) {
        this.getOrderList();
        this.GetRemitNum();
      } else if (index == 1) {
        this.getRecordsInfo();
      }
    },

    async init() {
      await this.userInfo();

      this.getOrderList();

      this.GetRemitNum();
      this.getShopData()
    },
    // 全选
    handleCheckAll() {
      let list = [];
      this.orderList.forEach(item => {
        item.select = true;
      });
      this.checkedAll = true;
      this.monthList = list;
    },
    handleCheckAllFlase() {
      this.orderList.forEach(item => {
        item.select = false;
      });
      this.checkedAll = false;
      this.monthList = [];
    },
    //单选上传发票监听
    handleCheckInvoice() {
      const list = []
       this.recordsData.list.forEach(item => {
        if(item.status === 7){
          list.push(item.id); // 将每个billNo添加到数组中
        }
      });
      this.checkedInvoiceAll =
        this.chosedBill.length === list.length;
    },
    // 结算发票全选
    handleCheckInvoiceAll() {
      let list = [];
      this.recordsData.list.forEach(item => {
        if(item.status === 7){
          list.push(item.id); // 将每个billNo添加到数组中
        }
      });
      if(list.length<1){
         this.checkedInvoiceAll = false;
         this.chosedBill = [];
         return
      }
      
      this.checkedInvoiceAll = true;
      this.chosedBill = list;
    },
    handleCheckInvoiceAllFlase() {
      this.checkedInvoiceAll = false;
      this.chosedBill = [];
    },
    //单选
    handleRadio() {
      let sumPrice = 0,
        sumOrder = 0;
      this.orderList.forEach(item => {
        if (item.select) {
          this.checkedAll = true;
        }
        if (!item.select) {
          this.checkedAll = false;
        }
        if (item.select) {
          sumPrice += item.totalAmount;
          sumOrder += item.shopBillQuantity;
        }
      });
      this.sumPrice = sumPrice;
      this.sumOrder = sumOrder;
    },
    // 一键申请
    async handleApplyBill() {
      if (this.signFlag !== 0 && this.signFlag !== '0' && (!this.assignment || this.assignment === '0' )) return this.visibleAssign = true
      if (this.applyNum >= 1) return (this.noApplyVisible = true);
      else if (this.applyNum < 1) return (this.remitVisible = true);
      else if (
        !this.shopBankCardInfo.bankAccountName ||
        !this.shopBankCardInfo.bankName
      )
        return (this.infoVisible = true);
    },
    // 查询商户结款次数
    async GetRemitNum() {
      let data = await tuhu.fetch(`${config.apis.GET_MERCHANT_NUM}`, {
        method: "post",

        body: JSON.stringify({
          shopId: this.shopId
        })
      });
      if (data.code === "200") {
        this.applyNum = data.data.chargeCount;
        this.sucessNum = 1 - (data.data.chargeCount || 0);
        this.shopBankCardInfo = data.data.shopBankCardInfo || {};
      } else {
        tuhu.toast(data.message || "网络错误");
      }
    },
    // handleItem
    async handleItem(item, index) {
      this.getOrderListMonth(item.month);
    },
    // 关闭申请
    close() {
      this.remitVisible = false;
      this.checked = false;
      this.childIndex = 0;
    },
    // 暂不申请
    async handleNoApply() {
      //   location.reload();
      this.tabIndex = 0;
      this.childIndex = 0;
      this.monthList = [];
      this.init();
      this.close();
    },
    //发票必传时候提示
    handleInvoiceApply(){
      if (!this.shopBankCardInfo.bankAccountName)
        return tuhu.toast("请先添加收款账户");
      if (!this.checked) return tuhu.toast("请确认收款信息");
      this.isShowTips = true
    },
    // 立即申请
    handleApply() {
      if (!this.shopBankCardInfo.bankAccountName)
        return tuhu.toast("请先添加收款账户");
      if (!this.checked) return tuhu.toast("请确认收款信息");
      this.childIndex = 1;
      this.remitVisible = false;
      this.isShowTips = false
      this.checked = false;
      this.getOrderList(5);
    },
    // handleApply1
    async handleApply1(status) {
      // this.monthList
      let list = [];
      this.orderList.forEach(item => {
        if (item.select) {
          list.push(item.month);
        }
      });
      if (this.orderList.length <= 0) return tuhu.toast("暂无账单");
      if (!list.length) return tuhu.toast("请先选择一笔订单");
      let data = await tuhu.fetch(`${config.apis.TO_SHOP_ACCOUNT}`, {
        method: "post",
        body: JSON.stringify({
          monthList: list,
          shopId: Number(this.shopId),
          status,
          year: this.yearValue
        })
      });
      if (data && data.code === "200") {
        tuhu.toast(data.message);
        this.sumOrder = 0;
        this.sumPrice = 0;
        this.checkedAll = false;
        this.handleNoApply();
      } else {
        tuhu.toast(data.message || "网络错误");
      }
    },
    // 身份信息
    async userInfo() {
      try {
        const res = await tuhu.fetch(`${config.apis.GET_USERINFO}`);
        if (res && res.code === "200") {
          this.userRole = res.data.role;
          this.shopId = res.data.shopId;
        } else {
          tuhu.toast(res.message || "网络错误或权限不足");
          console.log(`${config.apis.GET_USERINFO}`, res);
        }
      } catch (e) {
        console.log(`${config.apis.GET_USERINFO}`, e);
      }
    },
    // 出账订单
    async getOrderList(status = "") {
      tuhu.showIndicator();

      try {
        let data = await tuhu.fetch(`${config.apis.GET_MERCHANT_YEAR}`, {
          method: "post",

          body: JSON.stringify({
            year: this.yearValue,
            month: "",
            status: status,
            shopId: this.shopId
          })
        });

        if (data && data.code === "200") {
          tuhu.hideIndicator();
          if (data.data && data.data.length > 0) {
            this.orderList = data.data;

            let num = 0,
              price = 0;
            data.data.forEach(item => {
              num += item.shopBillQuantity;
              price += item.totalAmount;
            });
            this.countOrderNum = num;
            this.countOrderPrice = parseFloat(price.toFixed(2));
            if (data.data[0].month) {
              this.getOrderListMonth(data.data[0].month);
            }
          } else {
            this.countOrderNum = 0;
            this.countOrderPrice = 0;
            this.orderList = [];
          }
        } else {
          tuhu.hideIndicator();

          tuhu.toast(data.message || "网络错误");
        }
      } catch (e) {
        tuhu.hideIndicator();

        console.log(`${config.apis.SETTLEMENT_LIST}`, e);
      }
    },

    async getOrderListMonth(month) {
      tuhu.showIndicator();

      try {
        let data = await tuhu.fetch(`${config.apis.GET_MERCHANT_MONTH}`, {
          method: "post",
          body: JSON.stringify({
            year: this.yearValue,
            // month: month,
            monthList: [month],
            status: "",
            shopId: this.shopId
          })
        });

        if (data && data.code === "200") {
          tuhu.hideIndicator();
          this.childrenOrder = data.data;
        } else {
          tuhu.hideIndicator();

          tuhu.toast(data.message || "网络错误");
        }
      } catch (e) {
        tuhu.hideIndicator();

        console.log(`${config.apis.SETTLEMENT_LIST}`, e);
      }
    },
    // 结款数据
    async getRecordsInfo() {
      try {
        let data = await tuhu.fetch(`${config.apis.SETTLEMENT_LIST}`, {
          method: "post",

          body: JSON.stringify({
            pageNum: 1,

            pageSize: 50,

            shopId: Number(this.shopId),

            year: this.yearValue
          })
        });

        if (data && data.code === "200") {
          this.recordsData = data.data;

          let num = 0,
            price = 0;
          data.data.list.forEach(item => {
            num += item.billCount;
            price += item.settlementPrice;
          });
          this.countOrderNum2 = num;
          this.countOrderPrice2 = parseFloat(price.toFixed(2))
        } else {
          console.log(`${config.apis.SETTLEMENT_LIST}`, data);

          tuhu.toast(data.message || "网络错误");
        }
      } catch (e) {
        console.log(`${config.apis.SETTLEMENT_LIST}`, e);
      }
    },
    // 分页事件
    async changePage(index) {
      const pageNum = index;
      let data = await tuhu.fetch(`${config.apis.SETTLEMENT_LIST}`, {
        method: "post",
        body: JSON.stringify({
          pageNum: pageNum,
          pageSize: 50,
          shopId: this.shopId,
          year: this.yearValue
        })
      });
      if (data && data.code === "200") {
        this.recordsData = data.data;
        let num = 0,
          price = 0;
        data.data.list.forEach(item => {
          num += item.billCount;
          price += item.settlementPrice;
          
        });
        this.countOrderNum2 = num;
        this.countOrderPrice2 = price;
      } else {
        tuhu.toast(data.message || "网络错误");
      }
    },
    async submit() {
      //   this.remitVisible = true;
      //   if (!this.orderList) return false;
      //   tuhu.navigateTo({
      //     url: "/pages/confirmInfo/index",
      //     query: {
      //       sId: this.shopId,
      //       seId: this.orderList && this.orderList.id,
      //     },
      //   });
    },
    onPageBack(to, from) {
      if (from.path.indexOf("pages/confirmInfo/index") > -1) {
        this.init();

        this.tabIndex = 1;
      }
    },
    //去完善信息
    goUdate() {
      tuhu.navigateTo({ url: `/pages/accounts/index?${this.userInfo.shopId}` });
    },
    //刷新银行卡信息
    handleBackButton() {
      this.GetRemitNum();
    },
    // 检验账单信息
    async checkBillSatus() {
      let list = [];
      this.orderList.forEach(item => {
        if (item.select) {
          list.push(item.month);
        }
      });
      if (this.orderList.length <= 0) return tuhu.toast("暂无账单");
      if (!list.length) return tuhu.toast("请先选择一笔订单");
      let data = await tuhu.fetch(`${config.apis.GET_MERCHANT_MONTH}`, {
        method: "post",
        body: JSON.stringify({
          year: this.yearValue,
          // month: month,
          monthList: list,
          status: "",
          shopId: this.shopId
        })
      });
      if (data && data.code === "200") {
        let allData = data.data;
        if (allData && allData.length) {
          let djArr = allData.filter(item => item.status == 6); // 冻结数据
          if (djArr.length && djArr[0]["shopBillQuantity"] > 0) {
            let wczArr = allData.filter(item => item.status == 5); //未出账数据
            this.djNum = djArr[0]["shopBillQuantity"];
            this.kczNum =
              wczArr[0]["shopBillQuantity"] - djArr[0]["shopBillQuantity"];
            if (this.kczNum >= 0) {
              this.isShow = true;
            } else {
              this.handleApply1(5);
            }
          } else {
            this.handleApply1(5);
          }
        } else {
          this.handleApply1(5);
        }
      } else {
        tuhu.hideIndicator();
        tuhu.toast(data.message || "网络错误");
      }
    },
    // 确认立即申请
    submitApply() {
      if (this.kczNum > 0) {
        this.handleApply1(7);
      } else {
        this.isShow = false;
        tuhu.toast("暂无可出账订单");
      }
    }
  }
};
</script>
<style lang="less" scoped>
._content {
  font-size: 0.7rem;
  background: #f5f5f5;
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  .custormTips4{
    width: 14rem;
    min-height: 6rem;
    .t-content4{
      text-align: center;
      line-height: 3rem;
      height:3rem;
  }
}
  .upload-invoice-confirm {
    height: 100%;
    width: 18.75rem;
    position: fixed;
    top: auto;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: flex-end; /* 从下往上弹出 */
    z-index: 1000;
    .popup-content {
      width: 18.75rem;
      height: 11.48rem;
      background: #ffffff;
      border-radius: 0.75rem 0.75rem 0rem 0rem;
      padding: 1rem 1.25rem;
      max-width: 600px; /* 可根据需要调整 */
      animation: slideUp 0.3s ease-out;
      display: flex;
      justify-content: center;
      flex-direction: column;
      .popup-cont-pic {
        width: 16.75rem;
        display: flex;
        flex-direction: row;
        height: 5.93rem;
        .popup-cont-piccont-left {
          margin-right: 1.13rem;
          background-size: 100% 100%;
          background-repeat: no-repeat, no-repeat;
          background-position: center;
          width: 7.25rem;
          height: 4.88rem;
          border-radius: 0.4rem;
          background-image: url("https://res.xiaokunkeji.cn/image/2025/09/12/d4bccb2a63784e8eb0801f7d5f3f376b.png");
        }
        .popup-cont-piccont-right {
          margin-left: 1.12rem;
          width: 7.25rem;
          height: 5.93rem;
          display: flex;
          align-items: center;
          flex-direction: column;
          p {
            width: 7.25rem;
            text-align: center;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 0.65rem;
            color: #333333;
            line-height: 0.65rem;
            font-style: normal;
          }
          .img-div {
            margin-bottom: 0.4rem;
            width: 7.25rem;
            height: 4.88rem;
            background: #ffffff;
            border-radius: 0.4rem;
            display: flex;
            align-items: center;
            justify-content: center;
            border: 0.03rem solid #e9eaee;
            img {
              width: 6.53rem;
              height: 4.35rem;
            }
          }
        }
        p {
          width: 2.6rem;
          height: 0.65rem;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 0.65rem;
          color: #333333;
          line-height: 0.65rem;
          text-align: left;
          font-style: normal;
        }
      }
      .popup-cont-pic2 {
        width: 15.75rem;
        display: flex;
        flex-direction: row;
        height: 4.88rem;
        .popup-cont-piccont-left {
          position: relative;
          margin-right: 1rem;
          background-position: center;
          width: 7.25rem;
          height: 4.88rem;
          border-radius: 0.4rem;
          .delete-btn {
            position:absolute;
            top:0.2rem;
            right:0.2rem;
            width:0.8rem;
            height:0.8rem;
            background:url('https://res.xiaokunkeji.cn/image/2025/09/16/0ac2f095f2754953890df57f239abf26.png') no-repeat;
            background-size: 100% auto;
            border-radius:50%;
            cursor:pointer;
            z-index:2;
            display:flex;
            align-items:center;
            justify-content:center;
            z-index: 10;
            /* 确保按钮显示在图片上方 */
            transition: all 0.2s;
          }
          .delete-btn:hover {
            background: #ff6b6b;
            /* 鼠标悬停效果 */
            transform: scale(1.1); /* 轻微放大效果 */
          }
          .delete-btn:active {
            transform: scale(0.95); /* 点击时缩小效果 */
          }
        }
      }
      .popup-bth {
        margin-top: 1.25rem;
        display: flex;
        align-content: space-between;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 0.65rem;
        line-height: 2.05rem;
        text-align: center;
        .popup-bth-left {
          margin-right: 0.7rem;
          width: 7.68rem;
          height: 2.05rem;
          color: #808080;
          background: #f2f2f2;
          border-radius: 0.25rem;
        }
        .popup-bth-right {
          margin-left: 0.7rem;
          width: 7.68rem;
          height: 2.05rem;
          color: #ffffff;
          background: #266cea;
          border-radius: 0.25rem;
        }
      }
    }
    @keyframes slideUp {
      from {
        transform: translateY(100%);
      }
      to {
        transform: translateY(0);
      }
    }
  }
  .main-cont {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    flex: 1;
  }
  @themeColor: rgb(51, 136, 255);
  .themeColor {
    color: @themeColor;
  }
  .colorRed {
    // color: rgb(215, 0, 0);
    color: rgb(230, 0, 0);
  }
  .fontWeight {
    font-size: 0.8rem;
    font-weight: 600;
  }
  .marginTop {
    margin-top: 0.5rem;
  }

  .paddingTop {
    padding-top: 0.75rem;
  }
  .paddingBottom {
    padding-bottom: 0.5rem;
  }
  .pay-tabs {
    width: 100%;
    height: 2rem;
    min-height: 2rem;
    display: flex;
    justify-content: space-around;
    align-items: center;
    background: #fff;
    .active-tab {
      position: relative;
      height: 2rem;
      line-height: 2rem;
      color: @themeColor;
    }
    .active-tab::before {
      content: "";
      position: absolute;
      width: 50%;
      height: 0.1rem;
      bottom: -0.25rem;
      left: 0.6rem;
      background: @themeColor;
    }
  }
  .orderCard {
    flex: 1;
    margin: 0.75rem;
    margin-top: 0;
    .bill-title {
      display: flex;
      justify-content: space-between;
      font-size: 0.65rem;
      .title {
        color: #010c22;
        font-size: 0.8rem;
        font-weight: 600;
        .title-num {
          display: inline-block;
          width: 1.85rem;
          min-width: 2rem;
          white-space: nowrap;
          height: 1rem;
          font-size: 0.7rem;
          color: #4069ff;

          background: #f2fafc;
          line-height: 1rem;
          font-weight: 400;
          text-align: center;
        }
      }
      .num {
        color: #4062ff;
        font-size: 0.7rem;
        font-weight: 500;
      }
    }
    .bill-info {
      .bill-info2 {
        height: 2rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .bill-num {
          font-size: 0.7rem;
          color: #010c22;
        }
        .bill-info2-status {
          font-size: 0.7rem;
          font-weight: 500;
          color: #010c22;
          .setClass {
            color: #fff;
            padding: 0.1rem 0.3rem;
            border-radius: 0.1rem;
            font-size: 0.6rem;
          }
        }
      }
    }
    .child2 {
      display: flex;
      flex-direction: column;
      height: 100%;
      .main {
        flex: 1;
        overflow-y: auto;
      }
      .top {
        display: flex;
        justify-content: space-between;
        .right {
          span {
            color: cornflowerblue;
          }
        }
      }
      .conten {
        .content-text {
          width: 100%;
          display: flex;
          align-items: center;
          background: #fff;
          height: 4.3rem;
          border-radius: 0.4rem;
          padding: 0.7rem 0.75rem;
          margin-top: 0.5rem;
          .span {
            background: #e9eeff;
            color: #4b56ff;
            border-radius: 0.1rem;
            font-size: 0.6rem;
            width: 3rem;
            height: 1.2rem;
            line-height: 1.2rem;
            text-align: center;
          }
          .right {
            margin-left: 0.75rem;
            flex: 1;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            .year {
              color: #4069ff;
              font-size: 0.7rem;
            }
            .num {
              color: #010c22;
              font-size: 0.8rem;
              display: flex;
              align-items: center;
              justify-content: space-between;
              .left {
                display: flex;
                align-items: center;
                justify-content: space-between;
              }
              .solid {
                background: #a2a6ae;
                margin: 0 0.5rem;
                width: 1px;
                height: 0.7rem;
                display: inline-block;
              }
            }
          }
        }
      }
    }
  }
  .btn2 {
    height: 3rem;
    min-height: 3rem;
    background: #fff;
    display: flex;
    padding: 0 0.75rem;
    align-items: center;
    justify-content: space-between;
    .center {
      margin-left: 0.5rem;
      display: flex;
      .center-count {
        width: auto;
        .count {
          display: flex;
          align-items: center;
          height: 0.55rem;
          white-space: nowrap;
          margin: 0.4rem 0;
          color: #010c22;
          font-size: 0.7rem;
          span {
            color: #4c6aff;
            font-size: 1.1rem;
          }
          img {
            width: 0.5rem;
            height: 0.55rem;
          }
        }
        .count-name {
          color: #898e98;
          font-size: 0.6rem;
          .span {
            color: #4069ff;
          }
        }
      }
      .a-apply {
        width: 3.2rem;
        font-size: 0.8rem;
        color: #ffffff;
        line-height: 2rem;
        background: linear-gradient(180deg, #6d8bff 0%, #557afe 100%);
        border-radius: 1.1rem;
        width: 5.5rem;
        height: 2rem;
        text-align: center;
        margin-left: 0.5rem;
      }
    }
  }
  .upload-invoice {
    padding-top: 0.75rem;
    width: 18.75rem;
    height: 3.5rem;
    background: #ffffff;
    box-shadow: 0rem -0.05rem 0.1rem 0rem rgba(241, 241, 241, 0.5);
    display: flex;
    flex-wrap: nowrap;
    .upload-invoice-btn-left {
      padding-left: 1.35rem;
      display: flex;
      width: 11.75rem;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      height: 2rem;
      font-size: 0.65rem;
      color: #808080;
      text-align: left;
      font-style: normal;
    }
    .upload-invoice-btn-right {
      width: 6.25rem;
      margin-right: 0.75rem;
      height: 2rem;
      background: #266cea;
      border-radius: 0.35rem;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 0.65rem;
      color: #ffffff;
      line-height: 2rem;
      text-align: center;
      font-style: normal;
    }
  }
  .recordsCard {
    flex: 1;
    position: relative;
    width: 100%;
    height: 100%;
    overflow: auto;
    padding: 0.5rem 0.75rem;
    .recordsCard-box {
      display: flex;
      flex-direction: column;
      background: #fff;
      border-radius: 0.4rem;
      padding: 0.75rem;
      .box-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 0.7rem;
        position: relative;

        .solid {
          width: 0.1rem;
          height: 0.8rem;
          background: #4069ff;
          border-radius: 0.05rem;
          position: absolute;
          left: -0.75rem;
        }
        .val2 {
          color: #f59a23;
        }
        .val {
          color: #262f42;
          .setClass {
            color: #fff;
            padding: 0.1rem 0.3rem;
            border-radius: 0.1rem;
            font-size: 0.6rem;
          }
        }
        .title {
          white-space: nowrap;
          color: #898e98;
        }
      }
      .bottom-line {
        .title {
          display: flex;
          align-items: center;
          justify-content: start;
          color: #010c22;
          font-weight: 600;
        }
      }
      .orderNum {
        display: flex;
        justify-content: space-between;
        margin-top: 0.75rem;
        color: #4069ff;
        .orderName {
          font-size: 0.65rem;
        }
        span {
          font-size: 0.8rem;
          font-weight: 600;
        }
      }
    }
  }
  .btn {
    height: 3rem;
    padding: 0.2rem 0.75rem 0 0.75rem;
  }
}
.bill {
  .bill-flex {
    display: flex;
    justify-content: space-between;
    height: 2rem;

    background: #fff;
    padding: 0 0.7rem;
    align-items: center;
    font-size: 0.7rem;
    span {
      color: cornflowerblue;
    }
  }
}
.custormRemit {
  padding: 0 1rem 1rem 1rem;
  display: flex;
  flex-direction: column;
  .custormRemit-content{
    height:20rem;
    overflow-y: auto;
    .account {
    height: auto;
    display: flex;
    // align-items: center;
    width: 100%;
    padding: 0.75rem;
    box-shadow: 0rem 0.1rem 0.6rem 0rem rgba(236, 237, 239, 0.7);
    background: #fff;
    p:nth-child(1) {
      font-size: 0.7rem;
      color: #010c22;
      height: 1rem;
      line-height: 1rem;
      white-space: nowrap;
      margin-right: 0.5rem;
    }
    p:nth-child(2) {
      font-size: 0.7rem;
      color: #4069ff;
      text-align: right;
      flex: 1;
    }
  }
  .first {
    border-bottom: 1px solid #ebedf0;
  }
  .explain {
    margin-bottom: 1rem;
    margin-top: 0.8rem;
    .explain-title {
      font-size: 0.7rem;
      color: #101114;
      line-height: 1rem;
      margin-bottom: 0.3rem;
      font-weight: 600;
    }
    .explain-info {
      color: #616264;
      font-size: 0.65rem;
      line-height: 1.3rem;
    }
  }
  }
  .title {
    text-align: center;
    padding: 0.7rem 0;
    font-size: 0.8rem;

    font-weight: 600;
    color: #444;
  }
  .title2 {
    color: #fc1a00;
    text-align: center;
    font-size: 0.7rem;
    margin-top: 0.3rem;
    background: #fff9f2;
    height: 2rem;
    line-height: 2rem;
  }
  //   .first{
  //     margin-bottom: .7rem;
  // }

  .btn-2 {
    bottom: 0.5rem;
    display: flex;
    justify-content: space-between;
    p {
      width: 8rem;
      height: 2rem;
      border-radius: 1.1rem;
      line-height: 2rem;
      text-align: center;
      font-size: 0.8rem;
    }
    .close {
      color: #a2a6ae;
      background: linear-gradient(180deg, #f3f3f3 0%, #f2f2f2 100%);
    }
    .confim {
      color: #fff;
      background: linear-gradient(180deg, #6d8bff 0%, #557afe 100%);
    }
  }
}
.applycustorm {
  width: 90%;
  // padding: 1rem;
  border-radius: 0.8rem;
  .title {
    color: #fc1a00;
    font-size: 0.7rem;
    text-align: center;
    // padding: 1rem 0rem 0rem 0;
    height: 2rem;
    background: #fff9f2;
    line-height: 2rem;
    margin: 1.2rem 0.75rem 0;
  }
  .explan {
    color: #323233;
    font-size: 0.8rem;
    margin-top: 1.2rem;
    margin-bottom: 0.75rem;
    padding: 0 1rem;
    text-align: center;
    font-weight: 600;
  }
  .text {
    font-size: 0.7rem;
    line-height: 1.1rem;
    margin-bottom: 1.2rem;
    padding: 0 1rem;
    color: #262f42;
  }
  .btn {
    height: 2.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #4078ff;
    border-top: 1px solid #ccc;
    font-size: 0.8rem;
  }
}
.header-bg {
  position: relative;
  width: 100%;
  .img-bg {
    background: url(../../imgs/tc-icon-9.png) no-repeat;
    background-size: 100% 100%;
    min-height: 9.3rem;
    height: 9.3rem;
    position: absolute;
    width: 100%;
  }
  .con-bg {
    position: relative;
    margin: 0.75rem 0.75rem 0.5rem 0.75rem;
    background: #fff;
    border-radius: 0.4rem;
    padding: 0.75rem;
    .select-year {
      z-index: 1000;
      background: url(../../imgs/icon-1.png) no-repeat;
      background-size: 100% auto;
      height: 1.5rem;
      width: 4.7rem;
      position: relative;
      left: -0.95rem;
      .select {
        // text-align-last: center; // text-align: center;
        position: relative;
        .yearClass {
          line-height: 1.5rem;
          margin-left: 1rem;
          color: #fff;
          font-size: 0.8rem;
        }
        .up {
          width: 0.6rem;
          height: 0.35rem;
          position: absolute;
          top: 0.55rem;
          right: 1rem;
        }
        .yearUl {
          background: #fff;
          box-shadow: 0rem 0.1rem 0.2rem 0rem #f1f1f1;
          .yearLi {
            height: 1.5rem;
            width: 4.7rem;
            line-height: 1.5rem;
            background: #fff;
            text-align: center;
          }
          .acbg {
            background: #f5f5f5;
            color: #333;
          }
        }
        .select-menu {
          border: none;
          background: none;
          width: 4.7rem;
          height: 1.5rem;
          color: #fff;
          .menu-data {
            color: #333;
          }
        }
      }
    }
    .order-num {
      display: flex;
      justify-content: space-between;
      margin-top: 0.75rem;
      .order {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-items: center;
        .text {
          color: #585f6d;
          font-size: 0.7rem;
        }
        .num {
          font-size: 1.2rem;
          font-weight: 500;
          color: #010c22;
        }
      }
    }
    .header-tips {
      background: rgba(254, 131, 0, 0.05);
      border-radius: 0.2rem;
      font-size: 0.6rem;
      color: #ff5000;
      line-height: 0.9rem;
      padding: 0.5rem;
      margin-top: 0.75rem;
    }
  }
}
.infocustorm {
  border-radius: 0.4rem;
  width: 80%;
  .title {
    font-size: 0.8rem;
    font-weight: 600;
    color: #323233;
    padding: 1.2rem 0;
    text-align: center;
  }
  .text {
    border-bottom: 1px solid #d4d6d9;
    padding: 0 1rem 1.2rem 1rem;
    line-height: 1.1rem;
    font-size: 0.7rem;
    color: #262f42;
  }
  .btn {
    height: 2.7rem;
    color: #4078ff;
    font-size: 0.8rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>

<style lang="less">
.classChecked {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  // justify-content: center;
  margin-bottom: 2.5rem;

  .van-checkbox {
    display: flex;
    align-items: center;
  }

  .van-checkbox__label {
    color: #010c22;
    font-size: 0.7rem;
  }

  .van-checkbox__icon {
    width: 0.8rem;
    height: 0.8rem;
  }

  .van-checkbox__icon {
    font-size: 0.8rem;
  }

  .van-checkbox__icon .van-icon {
    // width: .8rem;
    // height: .8em;
  }
}

.btn {
  display: flex;

  // justify-content: space-around;
  // align-content: center;
  .van-button {
    width: 7rem;
    height: 1.8rem;
  }
}

.collapse-bill {
  margin-bottom: 0.5rem;
  border-radius: 0.4rem;

  .van-cell--clickable {
    height: 2.4rem;
  }

  .van-icon {
    display: none;
  }

  .collapse-position {
    .van-cell {
      padding: 0.5rem;
    }

    .position {
      position: absolute;
      width: 0.1rem;
      height: 0.8rem;
      background: #4069ff;
      border-radius: 0.05rem;
      left: 0;
      top: 0.7rem;
    }
  }
}
.tips-dialog {
  .text {
    padding: 0.5rem;
    font-size: 0.7rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/settlementRecords/index.vue